var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM1.67217 8.5C1.67217 12.2709 4.72909 15.3278 8.5 15.3278C12.2709 15.3278 15.3278 12.2709 15.3278 8.5C15.3278 4.72909 12.2709 1.67217 8.5 1.67217C4.72909 1.67217 1.67217 4.72909 1.67217 8.5Z",
    fill: "#201D89"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.50039,
    cy: 8.50002,
    r: 5.1,
    fill: "#201D89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.d2f1194c2e6cf10b1cc7100de7f063e2.svg";
export { ForwardRef as ReactComponent };